'use client';

import Carousel, { CarouselItem } from "@/components/carousel";
import { spClient } from "@/utils/supabase/client";
import { Employee } from "@/types/spExportableSchema";
import { useState, useEffect } from "react";

export default function Instructors ()  {
  const [instructors, setInstructors] = useState<Employee[]>([]);

  useEffect(() => {
    getInstructors();
  }, []);

  const getInstructors = async () => {
    try {
      const { data, error } = await spClient
        .from('employees')
        .select('id, employee_type, first_name, last_name, profile_picture, title, is_active')
        .eq('employee_type', 'Profesor')
        .eq('is_active', true)
        .not('profile_picture', 'is', null)

        if (error) throw error;

        setInstructors(data as Employee[]);
    }
    catch (error) {
      console.error('Error fetching instructors', error);
    }
  };

  return (
    <section className="relative py-16 xl:mt-[80px]">
      <div className="relative mx-auto py-8 px-8 bigscreen-responsive bg-[#172618] rounded-[40px] xl:px-0 xl:mb-8">
        <div className="flex justify-center">
          <img src="/images/lines/halfCirclesDarkYellowGreen.png" className="absolute -top-[25px] z-10" alt="Decoration"/>
        </div>
        <h2 className="text-center text-yellow text-md font-bold uppercase py-4">Instructores</h2>
        <div className="flex flex-col justify-center items-center text-center text-white gap-4">
          <p className="font-bold text-xl md:text-3xl">Aprendé con los mejores en la industria</p> 
          <p className="max-w-3xl font-thin text-sm md:text-lg">Nuestro equipo cuenta con formación internacional de primer nivel, así como amplia trayectoria académica, 
            lo que nos permite ofrecerte una capacitación excepcional en el mundo culinario
          </p>
        </div>
        <div className="max-w-7xl w-full mx-auto px-8">
          <Carousel items={4} itemsMobile={1} bullets={false} arrows={true} nav={false}>
            { instructors?.map((instructor, index) => ( 
              <CarouselItem width="0" className="" key={index}>
                <div className="flex flex-col justify-center items-center w-full text-center mr-4 pb-8 pt-4">
                  <div className="bg-[#9ABE290F] rounded-full mb-6 mt-8 p-0.5 overflow-hidden">
                    <img src={`https://mercado.amura.cr/team/${instructor.id}/${instructor.profile_picture}`} alt="Imagen de perfil" className="w-[170px] h-[170px] rounded-full object-cover p-2"/>
                  </div>
                  <h6 className="text-white text-md font-bold bg-green rounded-bl-full rounded-tr-full px-8 py-1 mb-4"> { instructor.first_name } { instructor.last_name } </h6>
                  <p className="text-center text-white"> { instructor.title } </p>
                </div>
              </CarouselItem>              
            ))}
          </Carousel>
        </div>
      </div>
    </section>
  );
}
